var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNotificationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87502 18C9.11674 18 10.124 16.9928 10.124 15.75H5.62608C5.62608 16.9928 6.63331 18 7.87502 18ZM15.4473 12.7368C14.7681 12.0069 13.4972 10.909 13.4972 7.3125C13.4972 4.58086 11.5819 2.39414 8.99932 1.85766V1.125C8.99932 0.503789 8.49588 0 7.87502 0C7.25416 0 6.75073 0.503789 6.75073 1.125V1.85766C4.16815 2.39414 2.25284 4.58086 2.25284 7.3125C2.25284 10.909 0.981938 12.0069 0.30272 12.7368C0.0917821 12.9635 -0.00173351 13.2346 2.43066e-05 13.5C0.00389149 14.0766 0.456352 14.625 1.12854 14.625H14.6215C15.2937 14.625 15.7465 14.0766 15.75 13.5C15.7518 13.2346 15.6583 12.9632 15.4473 12.7368Z",
    fill: "#4EAACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationBlue);
export default __webpack_public_path__ + "static/media/ic-notification-blue.a1cac55c6db8eb6686debabc8c0bfe22.svg";
export { ForwardRef as ReactComponent };